import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/member')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/admin/member"!</div>
}
